module.exports = __webpack_public_path__ + "static/media/ma.07b0b91d.png";